// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }

  // Adding Labels
  var productTemplate = InstantSearchResultItemProduct.prototype.getTemplate;
  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
    if (tempType) return productTemplate.call(this, tempType);
 
  	return '<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}">' +
  	              '<a href="{{url}}" {{newTabAttribute}}>' + 
  	                  '{{itemProductImage}}' + 
                      '{{itemLabel}}' +
  	                  '<div class="{{class.searchSuggestion}}-right">' + 
  	                      '<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>' + 
  	                      '{{itemProductSku}}' + 
  	                      '{{itemProductVendor}}' +        
  	                      '{{itemProductPrice}}' + 
  	                  '</div>' + 
  	              '</a>' + 
  	          '</li>';
    
  }
  
  var productCompile = InstantSearchResultItemProduct.prototype.compileTemplate;
  
  InstantSearchResultItemProduct.prototype.compileTemplate = function() {  
    if (!this.isShow) return '';      
   
    var itemHtml = productCompile.call(this);
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, buildLabel(this.data)); 
    
    return itemHtml;
  }
 
  function buildLabel (data) {
 
    var html = '';

    if(Utils.getProductMetafield(data, 'custom', 'shipping_restriction_info') != null){
      html = `<div class="isw-label shipping_restriction_info">${Utils.getProductMetafield(data, 'custom', 'shipping_restriction_info')}</div>`;
      }

    return html;
  }
})();